// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  versonaId: __t.u64().primaryKey().name("versona_id"),
  worldId: __t.u64().name("world_id"),
  x0: __t.f32().name("x_0"),
  z0: __t.f32().name("z_0"),
  x1: __t.f32().name("x_1"),
  z1: __t.f32().name("z_1"),
  x2: __t.f32().name("x_2"),
  z2: __t.f32().name("z_2"),
  x3: __t.f32().name("x_3"),
  z3: __t.f32().name("z_3"),
  n: __t.u8(),
  stepM: __t.f32().name("step_m"),
  updatedAt: __t.timestamp().name("updated_at"),
});
